import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  Divider,
  IconButton,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import Axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import { connect } from "react-redux";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { url } from "../../../../config/config";
import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import CustomDialog from "../../../../Component/DialogBox/CustomDialog";
import CustomTableHead from "../../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomTableFooter from "../../../../Component/Table/CutomTableFooter/CustomTableFooter";
import { adminLogout } from "../../../../redux/action/action";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import SessionExpiredDialog from "../../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./ViewAuthor.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";
import SearchFilterAuthor from "../SearchFilterAuthor/SearchFilterAuthor";

class ViewAuthors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      search: {
        firstName: "",
        lastName: "",
      },
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Full Name",
        },
        {
          name: "Email",
        },
        {
          name: "Phone",
        },
        {
          name: "Actions",
        },
      ],
      author: [],
      dialogOpen: false,
      isEmpty: false,
      authorIdToDelete: "",
      notificationOpen: false,
      sesionExpired: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const response = await Axios.get(`${url}/api/authors`);
      if (response.data.length !== 0) {
        this.setState({
          author: response.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          author: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (error.response.data === "Invalid token.") {
        this.setState({ sessionExpired: true });
      }
    }
  };

  handleSearch = (e) => {
    this.setState({
      search: { ...this.state.search, [e.target.name]: e.target.value },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleAddAuthor = () => {
    this.props.history.push("/_administration_/author/add");
  };

  handleViewDetails = (authorId) => {
    this.props.history.push(`/_administration_/author/detail/${authorId}`);
  };

  handleEditAuthor = (authorId) => {
    this.props.history.push(`/_administration_/author/edit/${authorId}`);
  };

  handleDelete = async () => {
    let response = await Axios.delete(
      `${url}/api/authors/${this.state.authorIdToDelete}`,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (response.data.success) {
      this.handleDialogClose();
      this.handleNotificationOpen();
      this.getData();
    }
  };

  handleDialogOpen = (authorId) => {
    this.setState({
      dialogOpen: true,
      authorIdToDelete: authorId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  render() {
    const { rowsPerPage, page } = this.state;
    const { classes } = this.props;
    const filtered = this.state.author.filter((author) => {
      return (
        author.firstName
          .toLowerCase()
          .indexOf(this.state.search.firstName.toLowerCase()) !== -1 &&
        author.lastName
          .toLowerCase()
          .indexOf(this.state.search.lastName.toLowerCase()) !== -1
      );
    });
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          {this.state.sessionExpired === true && (
            <SessionExpiredDialog logout={() => this.props.adminLogout()} />
          )}

          <AdminPageTitle
            title="Author List"
            refreshUrl={this.props.match.url}
          />
          <Divider />
          <br />

          <SearchFilterAuthor
            data={this.state.search}
            handleChange={this.handleSearch}
          />

          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton onClick={this.handleAddAuthor} disableRipple>
                <AddCircleIcon style={{ color: "#1c2431" }} />
              </IconButton>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                Add New Author
              </div>
            </div>

            {this.state.author.length !== 0 ? (
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />
                  <TableBody>
                    {(rowsPerPage > 0
                      ? filtered.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : filtered
                    ).map((author, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor: `${index % 2 ? "#eee" : "white"}`,
                        }}
                      >
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          {`${author.firstName} ${author.lastName}`}{" "}
                        </TableCell>
                        <TableCell align="center">{author.email}</TableCell>
                        <TableCell align="center">{author.phone}</TableCell>
                        <TableCell align="center">
                          <Tooltip
                            arrow
                            title="View details"
                            className={classes.tooltip}
                            onClick={() => this.handleViewDetails(author._id)}
                          >
                            <InfoIcon />
                          </Tooltip>
                          <Tooltip
                            arrow
                            title="Edit"
                            className={classes.tooltip}
                            onClick={() => this.handleEditAuthor(author._id)}
                          >
                            <EditIcon />
                          </Tooltip>
                          <Tooltip
                            arrow
                            title="Delete"
                            className={classes.tooltip}
                            onClick={() => this.handleDialogOpen(author._id)}
                          >
                            <DeleteIcon />
                          </Tooltip>
                        </TableCell>
                        <CustomDialog
                          open={this.state.dialogOpen}
                          handleClose={this.handleDialogClose}
                          handleDelete={this.handleDelete}
                        />
                      </TableRow>
                    ))}
                  </TableBody>

                  <CustomTableFooter
                    count={filtered.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
                {this.showNotification(classes.notificationStyle)}
              </TableContainer>
            ) : this.state.isEmpty === true ? (
              <CustomEmptyMessage message="No data present in the database" />
            ) : (
              <CustomLoader />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewAuthors)));
